import React,{useEffect} from "react";
import { useHistory } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { getDate } from "../helpers/TimeDate";
import { FetchTransaction } from "../redux/actions/PlanAction";
import { initGA, initPixel } from "../helpers/CampaignEvents";

const TransactionDetails = () => {
  const dispatch = useDispatch();
  const transactions = useSelector((state) => state.PlanReducer.transactions);

  useEffect(() => {
    initPixel()
    initGA()
    dispatch(FetchTransaction());
  }, [])

  return (
    <div className=" pt-3 mb-4 ">
      <h1 className="ml-10">
        <i className="fas fa-shopping-cart"></i> Transaction History
      </h1>
      <hr />

      <div className="container-fluid transactiondetails">
     
          {
            transactions?
            transactions.map((data,i)=>(
              <div className="card trx_data" key={i}>
              <div className="d-md-flex d-lg-flex justify-content-between ">
              <span>
                <p> Order ID : {data.orderid} </p>
  
                <p>
                  Status : <span className={data.status === "Pending"?"text-success":data.status === "Success"?"text-primary":"text-danger"} >{data.status}</span>
                </p>
  
              </span>
              <span>
                <p>
                  {" "}
                  created at <span className="text-success">{getDate(data.date)}</span>
                </p>
                <p>
                  {" "}
                  Amount :{" "}
                  <span className={`font-weight-bold ${data.status === "Pending"?"text-success":data.status === "Success"?"text-primary":"text-danger"}`} id="countdown">
                    {" "}
                    {data.amount}
                  </span>
                  
                </p>
              </span>
            </div>
            </div>
            ))
            :""
          }

        </div>
      
    </div>
  );
};

export default TransactionDetails;
